if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        if (this.classList.contains('gl-media-modal')) {
          this.querySelectorAll('button').forEach((button) => {
            button.addEventListener('pointerup', (event) => event.stopPropagation());
          });
          this.querySelectorAll('[data-gl-media-step]').forEach((button) => {
            button.addEventListener('click', () => this.changeGrowthLabMedia(Number(button.dataset.glMediaStep)));
          });
          this.addEventListener('keydown', (event) => {
            if (!this.hasAttribute('open')) return;
            if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
              event.preventDefault();
              this.changeGrowthLabMedia(event.key === 'ArrowLeft' ? -1 : 1);
            }
          });
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      growthLabMedia() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      changeGrowthLabMedia(step) {
        const items = this.growthLabMedia();
        const current = items.findIndex((item) => item.classList.contains('active'));
        if (items.length) this.activateGrowthLabMedia(items[(current + step + items.length) % items.length]);
      }

      activateGrowthLabMedia(activeMedia) {
        const items = this.growthLabMedia();
        window.pauseAllMedia();
        items.forEach((item) => item.classList.toggle('active', item === activeMedia));
        const counter = this.querySelector('[data-gl-media-counter]');
        if (counter) counter.textContent = counter.dataset.format.replace('[current]', items.indexOf(activeMedia) + 1).replace('[total]', items.length);
        const container = this.querySelector('[role="document"]');
        container.scrollTop = 0;
        container.scrollLeft = 0;
        if (activeMedia.nodeName === 'DEFERRED-MEDIA') activeMedia.loadContent();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;
        if (this.classList.contains('gl-media-modal')) {
          this.activateGrowthLabMedia(activeMedia);
          return;
        }
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
